<app-top-nav></app-top-nav>
<ui-backdrop></ui-backdrop>
<app-loader></app-loader>
<div class="toast-stack" aria-live="polite" aria-atomic="true">
  <article
    *ngFor="let toast of toasts; trackBy: trackToast"
    class="toast"
    [class.toast--success]="toast.tone === 'success'"
    [class.toast--error]="toast.tone === 'error'"
    [class.toast--info]="toast.tone === 'info'">
    <div class="toast__body">
      <strong *ngIf="toast.title" class="toast__title">{{ toast.title }}</strong>
      <p class="toast__message">{{ toast.message }}</p>
    </div>
    <button type="button" class="toast__close" (click)="dismissToast(toast.id)" [attr.aria-label]="'common.close' | translate">
      x
    </button>
  </article>
</div>
<div class="app-body">
  <main class="app-content">
    @if (availableUpdate) {
      <section class="update-banner" role="status" aria-live="polite">
        <div class="update-banner__content">
          <strong class="update-banner__title">{{ updateBannerTitle }}</strong>
          <p class="update-banner__message">{{ updateBannerMessage }}</p>
        </div>
        <button type="button" class="update-banner__action" (click)="refreshForUpdate()">
          {{ updateBannerAction }}
        </button>
      </section>
    }
    @if (twitchScopeStatus) {
      <section class="update-banner update-banner--scopes" role="status" aria-live="polite">
        <div class="update-banner__content">
          <strong class="update-banner__title">{{ scopeBannerTitle }}</strong>
          <p class="update-banner__message">{{ scopeBannerMessage }}</p>
        </div>
        <button type="button" class="update-banner__action" (click)="reconnectTwitch()">
          {{ scopeBannerAction }}
        </button>
      </section>
    }
    <router-outlet></router-outlet>
  </main>
  @if (showFooter) {
    <ui-footer
      [copyrightTemplate]="footerCopyright"
      [cguLabel]="footerCguLabel"
      [privacyLabel]="footerPrivacyLabel">
    </ui-footer>
  }
</div>

